import { PageCriteria } from 'src/app/_models/page-criteria';

export class PolicyDocumentsFilterCriteria extends PageCriteria {
    accountNumber: string = "";
    years = [];
    policyNumbers = [];
    documentTypes = [];
}
